import './presentation/styles/main.scss';
import './presentation/scripts/vendor/accordion.css';

import 'polyfill-array-includes';
import smoothscroll from 'smoothscroll-polyfill';
import './presentation/scripts/vendor/componentUtils.js';
import './presentation/scripts/vendor/modal.js';
import './presentation/scripts/vendor/accordion.js';

import addictionCycleInit from './presentation/scripts/component.addiction-cycle.js';
import carouselInit from './presentation/scripts/component.carousel';
import menuInit from './presentation/scripts/component.menu.js';
import exitModalInit from './presentation/scripts/component.modal-exit.js';
import smoothScrollTo from './presentation/scripts/util.smoothScroll';

import screenshot from './presentation/scripts/util.screenshot.js';

//polyfills
smoothscroll.polyfill();

//menu
carouselInit();
menuInit();
//modal
exitModalInit();

//animation
addictionCycleInit();
smoothScrollTo();

//screenshot
screenshot();
